module.exports = __webpack_public_path__ + "static/12-bcb92c108aa3d5263ce937cfe31f29ad.jpeg";